import { gql } from "@apollo/client";

export const GET_WALLET_BALANCE_HISTORY = gql`
  query GetWalletBalanceHistory($walletId: String!, $limit: Int) {
    walletBalanceHistory(walletId: $walletId, limit: $limit) {
      id
      walletId
      previousBalance
      newBalance
      changeAmount
      changeType
      reason
      tradeId
      positionId
      timestamp
    }
  }
`;

export const GET_WALLET_ACTIVITIES = gql`
  query GetWalletActivities($walletId: String!, $limit: Int) {
    walletActivities(walletId: $walletId, limit: $limit) {
      id
      walletId
      type
      title
      description
      timestamp
      tradeId
      positionId
      amount
      metadata
    }
  }
`;

export const GET_WALLET_HISTORY = gql`
  query GetWalletHistory($filter: WalletHistoryFilterInput!) {
    walletHistory(filter: $filter) {
      balanceHistory {
        id
        walletId
        previousBalance
        newBalance
        changeAmount
        changeType
        reason
        tradeId
        positionId
        timestamp
      }
      activities {
        id
        walletId
        type
        title
        description
        timestamp
        tradeId
        positionId
        amount
        metadata
      }
    }
  }
`;

export const MANUAL_BALANCE_ADJUSTMENT = gql`
  mutation ManualBalanceAdjustment($input: ManualBalanceAdjustmentInput!) {
    manualBalanceAdjustment(input: $input) {
      id
      walletId
      previousBalance
      newBalance
      changeAmount
      changeType
      reason
      timestamp
    }
  }
`;

export const CREATE_BALANCE_HISTORY = gql`
  mutation CreateBalanceHistory($input: CreateBalanceHistoryInput!) {
    createBalanceHistory(input: $input) {
      id
      walletId
      previousBalance
      newBalance
      changeAmount
      changeType
      reason
      tradeId
      positionId
      timestamp
    }
  }
`;

export const CREATE_WALLET_ACTIVITY = gql`
  mutation CreateWalletActivity($input: CreateWalletActivityInput!) {
    createWalletActivity(input: $input) {
      id
      walletId
      type
      title
      description
      timestamp
      tradeId
      positionId
      amount
      metadata
    }
  }
`;

export const RECORD_TRADE_ACTIVITY = gql`
  mutation RecordTradeActivity(
    $walletId: String!
    $tradeId: Int!
    $action: String!
    $description: String
  ) {
    recordTradeActivity(
      walletId: $walletId
      tradeId: $tradeId
      action: $action
      description: $description
    ) {
      id
      walletId
      type
      title
      description
      timestamp
      tradeId
      positionId
      amount
      metadata
    }
  }
`;

export const RECORD_POSITION_ACTIVITY = gql`
  mutation RecordPositionActivity(
    $walletId: String!
    $tradeId: Int!
    $positionId: String!
    $action: String!
    $description: String
    $amount: Float
  ) {
    recordPositionActivity(
      walletId: $walletId
      tradeId: $tradeId
      positionId: $positionId
      action: $action
      description: $description
      amount: $amount
    ) {
      id
      walletId
      type
      title
      description
      timestamp
      tradeId
      positionId
      amount
      metadata
    }
  }
`;
